function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M326.5,80c-17.9-19.3-42.9-30-70.5-30c-27.7,0-52.8,10.6-70.6,29.8c-18,19.4-26.8,45.8-24.7,74.3 C164.7,210.3,207.5,256,256,256s91.2-45.7,95.3-101.9C353.4,125.9,344.6,99.5,326.5,80z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M417.9,462H94.1c-8.6,0.1-16.8-3.6-22.3-10.2c-6-7.1-8.4-16.9-6.6-26.8c7.8-43.1,32-79.2,70.1-104.6 c33.8-22.5,76.7-34.9,120.7-34.9s86.8,12.4,120.7,34.9c38.1,25.4,62.3,61.6,70.1,104.6c1.8,9.9-0.6,19.6-6.6,26.8 C434.6,458.3,426.4,462.1,417.9,462z"
});

var SvgPerson = function SvgPerson(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPerson, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/person.b8782b34.svg";
export { ForwardRef as ReactComponent };